/* eslint-disable no-magic-numbers */
import React, { useState } from "react";
import styles from "./styles.css";
import DummyMobile from "../../shared/dummy-mobile";
import InputMobile from "../../shared/input-mobile";
import Button from "../../shared/button";
import SocialIcon from "../../shared/icon-social";
import { sendCustomGaEvents } from "../../../tracking";
import PropTypes from "prop-types";
import { mobileNumberValidator } from "../../../utils/validators/mobile-number-validator";
import { mobileApps } from "./tracking";
import H1 from "../../shared/h1/component";

const AppInfo = ({
    fetchDownloadLinkConnect
}) => {

    const [mobile, setMobile] = useState("");
    const [isError, setIsError] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const handleClick = (eventAction) => {
        sendCustomGaEvents({
            ...mobileApps,
            eventAction
        });
    };

    const onSubmit = () => {
        if (mobileNumberValidator(mobile)) {
            setIsError(false);
            handleClick("text_link_button_download_page");
            fetchDownloadLinkConnect({ phone: mobile })
                .then(() => setIsSuccess(true))
                .catch(() => setIsSuccess(false));
        } else {
            setIsError(true);
            setIsSuccess(false);
        }
    };

    const onMobileChange = (e) => {
        if (isSuccess) setIsSuccess(false);
        setMobile(e.target.value);
        if (e.target.value.length === 10) {
            if (!mobileNumberValidator(e.target.value)) setIsError(true);
            else setIsError(false);
        }
    };

    const onBlurHandler = () => setIsError(!mobileNumberValidator(mobile));

    return (
        <div styleName={"styles.appOuter"}>
            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-5"}>
                        <DummyMobile />
                    </div>
                    <div className={"col-7"}>
                        <div styleName={"styles.leftPanel"}>
                            <H1 text="Get the Cars24 Mobile App" />
                            <p styleName={"styles.appDetail"}>Book an appointment to
                             sell your car in
                             one visit and get paid instantly. Experience a hassle-free process
                              where we take care of documentation like RC transfer.</p>
                            <h3>We'll send you a link,
                                 open it on your phone to download the app</h3>
                            <div styleName={"styles.detailWrap"}>
                                <InputMobile
                                    showError={false}
                                    onChange={onMobileChange}
                                    value={mobile}
                                    onBlurCallback={onBlurHandler}
                                    placeholder="Mobile Number" />
                                <Button
                                    text="TEXT APP LINK"
                                    onClick={onSubmit} />
                                {
                                    isError &&
                                    <small styleName={"styles.invalid"}>
                                        Error! Please enter a valid 10 digit mobile number
                                    </small>
                                }
                                {
                                    isSuccess &&
                                    <small styleName={"styles.successful"}>Successfully sent</small>
                                }
                            </div>
                            <div styleName={"styles.iconWrap"}>
                                <a href="https://play.google.com/store/apps/details?id=com.cars24.seller&hl=en_IN" target="_blank">
                                    <SocialIcon
                                        onClick={() => handleClick("android_button_download_page")}
                                        name="googlePlay" />
                                </a>
                                <a href="https://apps.apple.com/in/app/cars24-sell-car-at-best-price/id1364492085" target="_blank">
                                    <SocialIcon
                                        onClick={() => handleClick("ios_button_download_page")}
                                        name="appStore" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

AppInfo.propTypes = {
    fetchDownloadLinkConnect: PropTypes.func
};

export default AppInfo;
